module.exports = __webpack_public_path__ + "img/step_2.e5b59f6e.jpg";